import { FormikErrors } from 'formik';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { EditableMetaData, FullViewBlock } from '../../components';
import { groupBy } from '../../helpers';
import { Group } from '../../helpers/groupBy';
import { MetaDataAccess, MetaDataValue, UseMetaDataActions } from '../../types/metadata';

type Props = {
  amountOfButtons?: number;
  metaDatas: MetaDataValue[];
  metaDataActions?: UseMetaDataActions;
  errors: FormikErrors<{
    [key: string]: any;
    metadatas: MetaDataValue[];
  }>;
};

export const MetaDataInfo: React.FC<Props> = React.memo(({ amountOfButtons, metaDatas, metaDataActions, errors }) => {
  const { t } = useTranslation();
  const groupedMetaData = metaDatas.length > 0 ? (groupBy(metaDatas, 'category') as Group<MetaDataValue>) : [];

  return metaDatas.length > 0 ? (
    <React.Fragment>
      {Object.entries(groupedMetaData).map(([key, groupedMd]) =>
        groupedMd.filter((meta: MetaDataValue) => meta.accessibility !== MetaDataAccess.Hidden).length > 0 ? (
          <FullViewBlock amountOfButtons={amountOfButtons || 2} key={key}>
            <h2 className="block-title">{key !== 'undefined' ? key : t('general.other')}</h2>
            <div className="block-data">
              {groupedMd.map((metaDataItem: MetaDataValue) =>
                metaDataItem.accessibility === MetaDataAccess.Editable ? (
                  <EditableMetaData
                    key={metaDataItem.metadataId}
                    metaData={metaDataItem}
                    index={metaDatas.findIndex(
                      // eslint-disable-next-line max-nested-callbacks
                      (metaData: MetaDataValue) => metaData.metadataId === metaDataItem.metadataId
                    )}
                    metaDataActions={metaDataActions}
                    errors={errors}
                  />
                ) : null
              )}
            </div>
          </FullViewBlock>
        ) : null
      )}
    </React.Fragment>
  ) : null;
});
